import React, { useContext } from "react";
import { Outlet, Route, Routes } from 'react-router'
import Overview from './pages/overview/overview'
import MainNav from './components/mainNav'
import Create from './pages/events/create/create'
import Edit from './pages/events/edit/edit'
import EventTeam from './pages/events/team/team'
import EventStats from './pages/eventStats/eventStats'
import EventGallery from './pages/eventGallery/eventGallery'
import Attendees from './pages/attendees/attendees'
import Attendee from './pages/attendees/attendee/attendee'
import Sales from './pages/sales/sales'
import Team from './pages/team/team'
import Finance from './pages/finance/finance'
import Profile from './pages/profile/profile'
import Settings from './pages/settings/settings'
import Account from './pages/account/account'
import Page404 from './pages/404/404'
import { UserContext } from './context/user-context'
import LoginForm from './components/loginForm'
// import Marketing from './pages/attendees/attendees'
import Events from './pages/events/events'
import Footer from './components/footer'
import Header from './components/header'
import EventTickets from './pages/eventTickets/eventTickets'

export default function RoutesContainer() {
  const { userToken, isUserLoading } = useContext(UserContext)
  if (isUserLoading) {
    return
  }
  if (!userToken) {
    return (
      <>
        <Header/>
          <div className="loginForm-wrap">
            <LoginForm />
          </div>
        <Footer/>
      </>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* <Route index element={<Overview/>} /> */}
        <Route index element={<Events />} />
        <Route path="events" element={<Events />} />
        <Route path="events/create" element={<Create />} />
        <Route path="events/:event_id/team" element={<EventTeam />} />
        <Route path="events/:event_id/tickets" element={<EventTickets />} />
        <Route path="events/:event_id/stats" element={<EventStats />} />
        <Route path="events/:event_id/gallery" element={<EventGallery />} />
        <Route path="events/:event_id" element={<Edit />} />
        <Route path="attendees" element={<Attendees />} />
        <Route path="attendees/:user_id" element={<Attendee />} />
        <Route path="sales" element={<Sales />} />
        <Route path="team" element={<Team />} />
        <Route path="finance" element={<Finance />} />
        <Route path="profile" element={<Profile />} />
        <Route path="settings" element={<Settings />} />
        <Route path="account" element={<Account />} />
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  )
}

function Layout() {
  return (
    <div>
      <Header />
      <main className="black-bg text-white py-3">
      <MainNav />
      {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, like navigation. */}
      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <Outlet />
      </main>
      <Footer />
    </div>
  );
}
